"use client";
import {
  createContext,
  Dispatch,
  ReactElement,
  ReactNode,
  useContext,
  useReducer,
} from "react";
import { SnackbarProps } from "../components/Snackbar";

export enum SnackbarActionType {
  OPEN_SNACKBAR = "OPEN_SNACKBAR",
  CLOSE_SNACKBAR = "CLOSE_SNACKBAR",
  RESET_SNACKBAR = "RESET_SNACKBAR",
}

type ActionType = {
  type: SnackbarActionType;
  //TODO: fix any (Todo: Shirish759)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
};

const initialState: SnackbarProps = {
  open: true,
  text: "",
};

export const SnackBarContext = createContext<
  [SnackbarProps, Dispatch<ActionType>]
>([initialState, () => {}]);

const reducer = (state: typeof initialState, action: ActionType) => {
  switch (action.type) {
    case SnackbarActionType.OPEN_SNACKBAR:
      return {
        ...state,
        open: true,
        ...action.payload,
      };

    case SnackbarActionType.CLOSE_SNACKBAR:
      return {
        ...state,
        open: false,
        text: "",
      };
    case SnackbarActionType.RESET_SNACKBAR:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const SnackBarProvider = ({
  children,
}: {
  //TODO: fix any (Todo: Shirish759)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactNode | ReactElement<any>;
}) => {
  const store = useReducer(reducer, initialState);
  return (
    <SnackBarContext.Provider value={store}>
      {children}
    </SnackBarContext.Provider>
  );
};

export const SnackBarConsumer = SnackBarContext.Consumer;

export const useSnackBarContext = () => useContext(SnackBarContext);
